import { render, staticRenderFns } from "./landing-obregon.vue?vue&type=template&id=25f88dc0&scoped=true&"
import script from "./landing-obregon.vue?vue&type=script&lang=js&"
export * from "./landing-obregon.vue?vue&type=script&lang=js&"
import style0 from "./landing-obregon.vue?vue&type=style&index=0&id=25f88dc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f88dc0",
  null
  
)

export default component.exports